import { useApi, createApiHook } from "../utils/apiUtils";

const useBuildQuestionnaireJson = () => {
  const { apiGet } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const buildJson = async (questionnaireId) => {
    startLoading();

    const response = await apiGet(`/questionnaires/${questionnaireId}/build-json`, "Error al construir el JSON del cuestionario");
    setResponse(response);

    if (response?.error) {
      const err = new Error(response.error.message || "No se pudo construir el JSON del cuestionario");
      err.backend = response.error;
      throw err;
    }
    return response?.data || null;
  };

  return { buildJson, data, loading, error };
};

export default useBuildQuestionnaireJson;
